import { useState } from 'react';

export function useUsedLocationSearch() {
  const [searchInput, setSearchInput] = useState('');
  const [searchCoordinates, setSearchCoordinates] = useState(null);
  return { searchInput, setSearchInput, searchCoordinates, setSearchCoordinates };
}
